export default "__VITE_ASSET__ChlJcAn8__"